import { LocalStorage } from 'saddlebag-localstorage';

import { logWarn } from './logger';

const DEFAULT_NAMESPACE = 'fss';
const namespacedStorages: Record<string, typeof LocalStorage> = {};

const getStorage = (namespace: string) => {
  namespacedStorages[namespace] = namespacedStorages[namespace] || new LocalStorage(namespace);
  return namespacedStorages[namespace];
};

export function tryGetValue<T>(
  key: string,
  defaultValue: T,
  namespace: string = DEFAULT_NAMESPACE,
): T {
  try {
    return getStorage(namespace).tryGetValue(key) ?? defaultValue;
  } catch (error) {
    logWarn({
      component: 'localStorage',
      message: error.message,
    });
    return defaultValue;
  }
}
export const trySetValue = (key: string, value: unknown, namespace: string = DEFAULT_NAMESPACE) => {
  try {
    return getStorage(namespace).trySetValue(key, value);
  } catch (error) {
    logWarn({
      component: 'localStorage',
      message: error.message,
    });
    return {};
  }
};
